export function activationPayload(code, defaultOrganizationId = "") {
  const match = String(code || "").trim().match(/^(?:([^\s:.]+):)?([^\s:.]+)\.([^\s:.]+)$/);
  if (!match) return null;
  return { organizationId: match[1] || defaultOrganizationId, userId: match[2], activationToken: match[3] };
}
